import React, { useEffect } from "react";
import moment from "moment";

export const IdleTimeOutHandler = (props) => {
  const events = ["click", "scroll", "load", "keydown"];
  const eventHandler = (eventType) => {
    const isTime = moment().valueOf();
    const sessionTime = sessionStorage.getItem("accessTokenTime") ?? isTime;
    const token = sessionStorage.getItem("accessToken");

    if (!token || token === "undefined" || isTime >= sessionTime) {
      RemoveSession();
      window.location.href = "/";
    }
  };

  useEffect(() => {
    async function fetchData() {
      addEvents();
      return () => {
        removeEvents();
      };
    }
    fetchData();
  }, []);

  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, eventHandler);
    });
  };
  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, eventHandler);
    });
  };

  return <></>;
};

export const AddSession = (data) => {
  //console.log(data);
  sessionStorage.setItem("accessToken", data.accessToken);
  sessionStorage.setItem("userId", data.userId);
  sessionStorage.setItem("displayName", data.displayName);
  sessionStorage.setItem("codeId", data.codeId);
  sessionStorage.setItem("passport", data.passport);
  sessionStorage.setItem(
    "accessTokenTime",
    moment().add(process.env.REACT_APP_SESSION_TIMEOUT_HOURS, "hours").valueOf()
  );
};

export const RemoveSession = () => {
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem("userId");
  sessionStorage.removeItem("displayName");
  sessionStorage.removeItem("codeId");
  sessionStorage.removeItem("passport");
  sessionStorage.removeItem("accessTokenTime");
};
